module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Row for Freedom: Crossing an Ocean In Search of Hope")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ttxi",
      "id": "iwxi"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")]), _vm._v("ll of us have adventure in the blood. Go back far enough into your family history and you’ll find the stories. An ancestor who left his homeland in search of a better life. A distant relative who fought against impossible odds and won. A family who took a risk and made a change.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s what adventure is. It’s about starting the search when we don’t know exactly what we’ll find. It’s about doing whatever it takes to make a change. It’s about saying yes to the struggle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And it’s part of all of us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The question is, how big an adventure is each of us going to live?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ve met a lot of people who have chosen to live their adventures as big as they possibly can. Some of them you know already; others you’ll never hear of. But all of them have made that same choice—to jump into the unknown for the sake of something bigger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I first met Julia as she was about to make that leap. I listened as she talked about rowing the Atlantic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was passionate and excited, and she didn’t really know what was waiting for her out there on the ocean. She had no idea "), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v(" how tough it would get. But she was prepared to risk it all to make a difference.")])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She had that look in her eyes. It told me she was ready.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I watched as the row started to unfold. I heard about things that went wrong out there on the ocean, but I knew that we were only hearing a small part of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When you’re in the middle of the adventure, you just have to live it. When you’re on an expedition, you put your head down and battle through. Storytelling happens after the finish line.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But now that time has come. A couple of years after landing in Barbados, Julia can tell her story. The full story.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Row for Freedom")]), _vm._v(" explains what it was really like for Julia and the others as they spent forty-five days hauling themselves across the Atlantic. It details the equipment failures and the emotional struggles. It explores the battles against time, weather, and exhaustion to make it across and break two Guinness World Records. It invites us on board and lets us feel the wind and waves for ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it also tells us more. It explains what life was like for Julia in the years and months before the row. It describes the fears and the struggles as family life was thrown into chaos. Knowing what she went through makes her adventure even more remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And "), _c('i', [_vm._v("Row for Freedom")]), _vm._v(" tells us why she did it all. It explains the passion that drives Julia—the unapologetic hope of changing the world. It shows us exactly how this ordinary girl from a London suburb became so passionate about a cause that she’d attempt something like this. It shows us what it’s like to wake up to the nightmare of modern-day slavery and realize that silence is not an option.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know what it’s like to chase a dream—and what it’s like to encounter fear in the process. Julia’s story tells it how it really is. She holds nothing back.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("Even though they called it the Row for Freedom, there were plenty of times when their journey felt the very opposite of liberty. It was tough and demanding. It was painful and relentless. It was frightening and dangerous.")])]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("It was like all the best expeditions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("Row for Freedom")]), _vm._v(" is a great story of a great adventure. It’s got all the best ingredients: struggles, setbacks, unforeseen changes, determined faith, plenty of risk, and—right at the very center of it all—a belief that this kind of thing is precisely what you and I were made for.")]), _vm._v(" "), _c('p', {
    staticClass: "txra"
  }, [_vm._v("Bear Grylls ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688f250c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 69
// module chunks = 0